import React, { Component } from 'react';
import { Modal, Form, Select, Button, notification } from 'antd';
import Request from "../../../request";
import { connect } from "react-redux";
import { showLoader, hideLoader } from "../../../modules/actions";

const { Option } = Select;

class AssignCounsellorModal extends Component {
    state = {
        counsellors: [],
        loading: false,
    };

    componentDidMount() {
        this.loadCounsellors();
    }

    loadCounsellors = async () => {
        try {
            let { data: allUsers } = await Request.loadUser({
                results: 10000,
                isCounsellor: true,
                active: true
            });
            this.setState({ counsellors: allUsers || [] });
        } catch (error) {
            console.error("Failed to load counsellors", error);
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                this.setState({ loading: true });
                this.props.dispatch(showLoader());
                try {
                    // Update inquiry using the same API used by edit inquiry
                    let payload = {
                        counsellorId: values.counsellorId,
                        subCounsellorId: values.subCounsellorId || [],
                        atLevel: "Front Desk", // Automatically move to Counselling Desk
                    };

                    let formData = new FormData();
                    formData.append("values", JSON.stringify(payload));
                    formData.append("_id", this.props.studentId);

                    let res = await Request.updateInquiryV2(this.props.studentId, formData);
                    if (!res.error) {
                        notification.success({ message: "Counsellor Assigned and Moved to Counselling Desk" });
                        this.props.onSuccess();
                    } else {
                        notification.error({ message: res.message || "Failed to update inquiry" });
                    }
                } catch (error) {
                    notification.error({ message: "An error occurred." });
                } finally {
                    this.setState({ loading: false });
                    this.props.dispatch(hideLoader());
                    this.props.onCancel();
                }
            }
        });
    };

    render() {
        const { visible, onCancel, form: { getFieldDecorator }, studentObj } = this.props;
        const { counsellors, loading } = this.state;

        return (
            <Modal
                title={`Assign Counsellor - ${studentObj ? studentObj.studentName : 'Student'}`}
                visible={visible}
                onCancel={onCancel}
                footer={null}
                destroyOnClose
            >
                <Form onSubmit={this.handleSubmit} layout="vertical">
                    <Form.Item label={<span style={{ fontWeight: 600 }}>Counsellor</span>}>
                        {getFieldDecorator("counsellorId", {
                            initialValue: studentObj && studentObj.counsellorId ? studentObj.counsellorId._id || studentObj.counsellorId : undefined,
                            rules: [{ required: true, message: "Please select a primary counsellor" }],
                        })(
                            <Select showSearch optionFilterProp="children" placeholder="Select Counsellor">
                                {counsellors.map(c => (
                                    <Option key={c._id} value={c._id}>{c.name}</Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item label={<span style={{ fontWeight: 600 }}>Sub-Counsellor</span>}>
                        {getFieldDecorator("subCounsellorId", {
                            initialValue: studentObj && studentObj.subCounsellorId ? studentObj.subCounsellorId : []
                        })(
                            <Select showSearch mode="multiple" optionFilterProp="children" placeholder="Select Sub Counsellors">
                                {counsellors.map(c => (
                                    <Option key={c._id} value={c._id}>{c.name}</Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>

                    <div style={{ textAlign: "right", marginTop: 24 }}>
                        <Button onClick={onCancel} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Save & Assign
                        </Button>
                    </div>
                </Form>
            </Modal>
        );
    }
}

const AssignCounsellorForm = Form.create()(AssignCounsellorModal);
export default connect()(AssignCounsellorForm);
